import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import PhoneInput from "react-phone-input-2";

import { faCamera } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import EG_Admin from "assets/icons/Subtraction.png";
import End_User from "assets/icons/end-user.png";
import EG_Consultant from "assets/icons/user-tie.png";
import Api_User from "assets/icons/Subtraction.png";
import TextField from "common/TextField";
import {
  BRANCH_ADMIN,
  BRANCH_CONSULTANT,
  INTERNAL_ADMIN,
  getIcon,
} from "common/constants/constants";
import UploadFileField from "common/formUI/uploadfileField";
import SearchableSelect from "components/common/searchableSelect/SearchableSelect";
import { useTranslation } from "react-i18next";
const GeneralInfo = (props) => {
  const { t } = useTranslation();
  const [profileImage, setProfileImage] = useState(null);
  const {
    formik,
    roles,
    handleChangeRole,
    next,
    back,
    handleCompletion,
    handleError,
    consultantList,
    setConsultant,
    setConsultantProduct,
    branchProducts,
  } = props;
  const {
    roleId: roleIdValue,
    firstName: firstNameValue,
    lastName: lastNameValue,
    email: emailValue,
    consultantId: consultantIdValue,
    consultantProduct: consultantProductValue,
    gender: genderValue,
    consultantHelperName: consultantHelperNameValue,
    companyName: companyNameValue,
    phoneNumber: phoneNumberValue
  } = formik.values;
  const {
    roleId: roleIdError,
    firstName: firstNameError,
    lastName: lastNameError,
    email: emailError,
    consultantId: consultantIdError,
    consultantProduct: consultantProductError,
    gender: genderError,
    consultantHelperName: consultantHelperNameError,
    companyName: companyNameError,
    phoneNumber: phoneNumberError,
  } = formik.errors;
  const {
    roleId: roleIdTouch,
    firstName: firstNameTouch,
    lastName: lastNameTouch,
    email: emailTouch,
    consultantId: consultantIdTouch,
    consultantProduct: consultantProductTouch,
    gender: genderTouch,
    consultantHelperName: consultantHelperNameTouch,
    companyName: companyNameTouch,
    phoneNumber: phoneNumberTouch,
  } = formik.touched;
  const STEP_ID = 2;
  const imgSrc = { End_User, EG_Consultant, EG_Admin, Api_User };
  const [disabled, setDisabled] = useState(() =>
    roleIdValue &&
      firstNameValue &&
      lastNameValue &&
      emailValue &&
      genderValue &&
      !roleIdError &&
      !firstNameError &&
      !lastNameError &&
      !emailError &&
      !genderError
      ? false
      : true
  );
  useEffect(() => {
    setDisabled(
      (JSON.parse(localStorage.getItem("userRole"))?.roleName ===
        INTERNAL_ADMIN ||
        JSON.parse(localStorage.getItem("userRole"))?.roleName ===
        BRANCH_ADMIN) &&
        roleIdValue == "#EU" &&
        !consultantIdValue
        ? true
        : roleIdValue == "#EC" && !consultantProductValue
          ? true
          : roleIdValue &&
            firstNameValue &&
            lastNameValue &&
            emailValue &&
            genderValue &&
            !roleIdError &&
            !firstNameError &&
            !lastNameError &&
            !emailError &&
            !genderError
            ? false
            : true
    );
  }, [
    roleIdValue,
    firstNameValue,
    lastNameValue,
    emailValue,
    consultantIdValue,
    genderValue,
    roleIdError,
    firstNameError,
    lastNameError,
    emailError,
    genderError,
    consultantProductValue,
  ]);

  useEffect(() => {
    if (!disabled) {
      handleError(STEP_ID, false);
      handleCompletion(STEP_ID, true);
    } else if (disabled) {
      handleError(STEP_ID, true);
      handleCompletion(STEP_ID, false);
    }
  }, [disabled]);

  const genderOptions = [
    { key: "gender", value: "male", label: t("male") },
    { key: "gender", value: "female", label: t("female") },
    { key: "gender", value: "other", label: t("other") },
  ];

  const onImageChange = (event, formik) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const fileName = file?.name;
      const extension = fileName?.split(".")?.pop()?.toLowerCase();
      const isSupported = ["jpg", "png", "jpeg"].includes(extension);
      if (isSupported) {
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = () => {
          formik.setFieldValue("profilePicture", file);
          setProfileImage(reader.result);
        };
      } else {
        toast.error(t("err-img-format"));
      }
    }
  };

  return (
    <>
      <div className="profile-picture-section">
        <div className="circle-icon">
          <img
            alt="not found"
            src={profileImage ? profileImage : "/assets/image/profile.png"}
          />
          <div className="overlay">
            <FontAwesomeIcon icon={faCamera} size="2x" color="white" />
            <input
              type="file"
              accept="image/png, image/jpeg"
              onChange={(event) => onImageChange(event, formik)}
            />
          </div>
        </div>
      </div>
      <h6 className="mt-4">{t("role")}</h6>
      <ul className="p-2">
        {roles?.map((item) => (
          <div
            role="button"
            onClick={() => {
              handleChangeRole(item);
              formik.setFieldValue("roleId", item.name);
              formik.setFieldValue("consultantId", "");
              formik.setFieldValue("consultantProduct", "");
            }}
          >
            <li
              key={item?.name}
              className=" d-flex justify-content-between align-items-start"
            >
              <div className="d-flex align-items-center">
                <img
                  src={imgSrc?.[item?.translatedValue.split(" ").join("_")]}
                  width="18px"
                />
                <span className="mx-2">{t(item?.name)}</span>
                <br></br>
              </div>
              <input
                role="button"
                type="radio"
                className="checkbox-input"
                aria-label="radio-1"
                name="admin"
                onKeyDown={(e) => {
                  if (e.key == "Enter") {
                    e.preventDefault();
                  }
                }}
                checked={roleIdValue === item.name}
              />
            </li>
            <hr />
          </div>
        ))}
        {roleIdTouch && roleIdError && (
          <p style={{ color: "red", fontSize: "12px" }}>{roleIdError}</p>
        )}
      </ul>
      <h6>{t("general-info")}</h6>
      <p style={{ fontSize: "small" }}>{t("user-info-description")}</p>
      {roleIdValue === "#AU" && <div className="inputField mt-2" style={{ backgroundColor: "#fff" }}>
        <TextField
          type="text"
          className="form-control"
          placeholder={t("companyName")}
          name="companyName"
          onChange={(event) =>
            formik.setFieldValue("companyName", event.target.value)
          }
          value={companyNameValue}
          error={companyNameTouch && companyNameError}
        />
      </div>}
      <div className="inputField mt-2" style={{ backgroundColor: "#fff" }}>
        <TextField
          type="text"
          className="form-control"
          placeholder={t("first-name")}
          name="firstName"
          onChange={(event) =>
            formik.setFieldValue("firstName", event.target.value)
          }
          value={firstNameValue}
          error={firstNameTouch && firstNameError}
        />
      </div>
      <div className="inputField  mt-2" style={{ backgroundColor: "#fff" }}>
        <TextField
          type="text"
          className="form-control"
          placeholder={t("last-name")}
          name="lastName"
          onChange={(event) =>
            formik.setFieldValue("lastName", event.target.value)
          }
          value={lastNameValue}
          error={lastNameTouch && lastNameError}
        />
      </div>
      <div className="inputField  mt-2" style={{ backgroundColor: "#fff" }}>
        <TextField
          type="text"
          className="form-control"
          placeholder={t("email")}
          name="email"
          onChange={(event) =>
            formik.setFieldValue("email", event.target.value)
          }
          value={emailValue}
          error={emailTouch && emailError}
        />
      </div>
      <div className="inputField mt-2" style={{ marginRight: "0.7rem" }}>
        <SearchableSelect
          name="gender"
          placeholder={t("select-gender")}
          handleChange={(key, value) => {
            formik.setFieldValue(key, value);
          }}
          options={genderOptions}
          value={genderValue}
          errors={genderTouch && genderError}
          withIcon
        />
      </div>
      {roleIdValue === "#AU" && <div className="inputField  mt-2">
        <PhoneInput
          country={"de"}
          value={phoneNumberValue}
          onChange={(phone) => {
            formik.setFieldValue("phoneNumber", phone);
          }}
          placeholder={t("phone-no")}
          containerClass="phoneNumberContainer"
          inputClass="phoneNumberInput"
        />
        {phoneNumberTouch && phoneNumberError && <ErrorMessage
          component="p"
          name={phoneNumberError?.message}
          style={{
            fontSize: "11px",
            color: "red",
            textAlign: "left !important",
          }}
        />}
      </div>}
      {/* <div className="inputField  mt-2" style={{ backgroundColor: "#fff", padding: "0 6px" }}>
        <UploadFileField
          fullWidth={true}
          formik={formik}
          name="profilePicture"
          extension="image/jpeg,image/png"
          fieldType="primary"
        />
      </div> */}
      {(JSON.parse(localStorage.getItem("userRole"))?.roleName ===
        INTERNAL_ADMIN ||
        JSON.parse(localStorage.getItem("userRole"))?.roleName ===
        BRANCH_ADMIN) &&
        roleIdValue === "#EU" && (
          <>
            <p className="mt-3" style={{ fontSize: "small" }}>
              {t("appoint-consultant")}
            </p>
            <div className="inputField mt-2" style={{ marginRight: "0.7rem" }}>
              <SearchableSelect
                name="consultantId"
                placeholder={t("select-consultant")}
                handleChange={(key, value) => {
                  formik.setFieldValue(key, value);
                  setConsultant(value);
                }}
                options={consultantList
                  ?.filter((x) => x.products.length > 0)
                  ?.map((consultant) => {
                    return {
                      value: consultant.id,
                      label: consultant.firstName + " " + consultant.lastName,
                      icon: getIcon[
                        consultant?.products[0]?.productKey
                          .replaceAll("#", "")
                          .toLowerCase()
                      ],
                    };
                  })}
                value={consultantIdValue}
                errors={consultantIdTouch && consultantIdError}
                withIcon
              />
            </div>
          </>
        )}

      {roleIdValue === "#EC" && (
        <>
          <p className="mt-3" style={{ fontSize: "small" }}>
            {t("consultant-for-product")}
          </p>
          <div className="inputField mt-2" style={{ marginRight: "0.7rem" }}>
            <SearchableSelect
              name="consultantProduct"
              placeholder={t("select-product")}
              handleChange={(key, value) => {
                formik.setFieldValue(key, value);
                setConsultantProduct(value);
              }}
              options={branchProducts
                ?.filter((e) => {
                  return e.assigned == "Active" && e.productKey != "#Esg";
                })
                .map((product) => {
                  return {
                    value: product.productKey,
                    label: product.translatedValue,
                    icon: getIcon[
                      product?.productKey.replaceAll("#", "").toLowerCase()
                    ],
                  };
                })}
              value={consultantProductValue}
              errors={consultantProductTouch && consultantProductError}
              withIcon
            />
          </div>
        </>
      )}

      {/* {JSON.parse(localStorage.getItem("userRole"))?.roleName === BRANCH_CONSULTANT && ( */}
      {roleIdValue === "#EU" && (
        <>
          <div className="inputField  mt-2" style={{ backgroundColor: "#fff" }}>
            <TextField
              type="text"
              className="form-control"
              placeholder={t("transferred-from")}
              name="consultantHelperName"
              onChange={(event) =>
                formik.setFieldValue("consultantHelperName", event.target.value)
              }
              value={consultantHelperNameValue}
              error={consultantHelperNameTouch && consultantHelperNameError}
            />
          </div>
        </>
      )}
      {/* )} */}

      <div className="d-flex justify-content-end align-items-center mt-5">
        <button
          className="parentbtn"
          style={{
            padding: "10px 35px",
            marginRight: "15px",
            backgroundColor: "gray",
          }}
          onClick={back}
        >
          BACK
        </button>
        <button
          className="parentbtn"
          style={{
            padding: "10px 35px",
            ...(disabled && { filter: "  opacity(30%)" }),
          }}
          disabled={disabled}
          onClick={next}
        >
          {t("next")}
        </button>
      </div>
    </>
  );
};

export default GeneralInfo;
